/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import { CDN } from '../../../constants';
import { ExpectedDateGenerator } from '../../../redux/helper/DateConverter';
import CategoryToolTip from '../../CategoryToolTip';

export default function ItemImageSection({prod}) {
    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;
    const profile = JSON.parse(localStorage.getItem('user'))?.profile
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    const [hoverId, sethoverId] = useState('');
    return (
        <div className="flex flex-wrap">
            <div className="xl:w-[75%] w-full pt-2">
                <div className="flex">
                    <div className="w-1/4">
                        <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                            <motion.img initial={{ opacity: 0, scale: 0.6 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{
                                    duration: 0.8,
                                    delay: 0.5,
                                    ease: [0, 0.71, 0.2, 1.01]
                                }} src={handleImage(prod?.IMAGE_NAME)} alt="icon" className="w-full" />
                        </Link>                        </div>
                    <div className="pl-2.5">
                        <div>
                            <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}><p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0,20)}...`:`${prod.DESCRIPTION}`}`}<span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit ml-2.5">{prod?.MAIN_CATEGORY}</span></p></Link>
                        </div>
                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {prod?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span>{prod?.AWS_CLASSIFICATION !== null && <span>AWS Classification: {prod?.AWS_CLASSIFICATION}</span>}</p>
                        <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                            <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                <p className="text-xs font-semibold text-[090406]">Category</p>
                                <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{prod?.DELIVERY_LEAD_TIME}</p>
                                <button  >
                                    <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer w-[12px]" onMouseEnter={()=>{
                                        setTimeout(() => {
                                            sethoverId(prod.INVENTORY_ITEM_ID)
                                        }, 1000);
                                    }} onMouseLeave={()=>{
                                        setTimeout(() => {
                                            sethoverId('')
                                        }, 2000);
                                    }}/>
                                </button>
                                {hoverId=== prod.INVENTORY_ITEM_ID &&(
                                    <CategoryToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID}/>
                                )}
                            </div>
                            <p className="text-xs font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">Expected Dispatch: <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME):'-'}</span></p>
                            <p className="text-xs font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">Method of Packing: <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span></p>
                        </div>
                    </div>
                    
                </div>
                <div className="lg:w-[70%] w-full sm:pl-4">
                    <p className="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">{prod?.DESCRIPTION}</p>

                </div>
            </div>
            <div className="xl:w-[25%] w-full pt-0">
                <div className="flex justify-end w-full xl:pr-[72px] pr-0 lg:mt-0 mt-3">
                    <p className={`sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit  xl:mb-0 mb-3 ${profile?.PRIVILAGES.includes('stock_visibility')?'':'opacity-0'}`}>Stock: {
                        DISTRIBUTOR?.PRIVILAGES.includes('stock_visibility') ? 
                            <span className="text-[#424446] font-semibold">
                                {prod?.STOCK_ONHAND_QTY} <>{prod?.PRIMARY_UOM_CODE}</></span>:0}</p>
                </div>
            </div>
        </div>
    )
}
